import { Link } from 'react-router-dom';

import { Links } from 'links';

import { EligibleOffer } from 'codegen';
import { TColumn } from 'types';

export const columns: TColumn<EligibleOffer>[] = [{
  width: 80,
  title: 'ID',
  dataIndex: 'order',
  render: (order, { id }) => (
    <Link to={`${Links.Offers}/${id}`}>
      {order}
    </Link>
  ),
}, {
  width: 200,
  title: 'Name',
  dataIndex: 'name',
}, {
  type: TColumn.type.Ellipsis,
  width: 200,
  title: 'Description',
  dataIndex: 'description',
}, {
  width: 80,
  title: 'Points',
  dataIndex: 'miles',
}, {
  type: TColumn.type.FetchImageByID,
  width: 80,
  title: 'Image',
  dataIndex: 'imageMetadataId',
}, {
  width: 80,
  title: 'Code',
  dataIndex: 'code',
}];
